module.exports = __webpack_public_path__ + "img/amex-icon.eb932358.png";